import React from 'react';
import styles from './Description.module.css'; // те же стили, что у оригинального MoneyState.tsx :contentReference[oaicite:8]{index=8}:contentReference[oaicite:9]{index=9}
import { useGetSelfQuery } from '../../../../../redux/services/TraderApi';
import formatNumber from '../../../../../utils/functions/formatNumber';
import { Loading } from '../../../../../components/Loading/Loading';

/**
 * SelfStats — «аналог» MoneyState.tsx,
 * но выводит дополнительные поля из get_self:
 * total_deposit_requests, total_withdrawal_requests,
 * balance_merchant_check, balance_withdrawal_usdt_check.
 */
const SelfStats: React.FC = () => {
  const { data: selfData, isLoading: selfLoading } = useGetSelfQuery(undefined, {
    pollingInterval: 10000,
  });

  if (selfLoading) {
    return <Loading />;
  }
  if (!selfData) {
    return <div className={styles.wrapper}>
      <div className={styles.block}>
        <h3 className={styles.title}>Не удалось загрузить<br />статистику</h3>
      </div>
    </div>;
  }

  return (
    <div className={styles.wrapper}>
      {/* Всего заявок на пополнение */}
      <div className={styles.block}>
        <h3 className={styles.title}>Заявки на пополнение</h3>
        <h4 className={styles.item}>
          <span className={styles.value}>
            {formatNumber(selfData.total_deposit_requests)}
          </span>
        </h4>
      </div>

      {/* Всего заявок на вывод */}
      <div className={styles.block}>
        <h3 className={styles.title}>Заявки на выплату</h3>
        <h4 className={styles.item}>
          <span className={styles.value}>
            {formatNumber(selfData.total_withdrawal_requests)}
          </span>
        </h4>
      </div>

      {/* Баланс мерчанта (чек) */}
      <div className={styles.block}>
        <h3 className={styles.title}>Пополнение</h3>
        <h4 className={styles.item}>
          <span className={styles.value}>
            {formatNumber(selfData.balance_merchant_check)}
          </span>
        </h4>
      </div>

      {/* Баланс вывода USDT */}
      <div className={styles.block}>
        <h3 className={styles.title}>Вывод</h3>
        <h4 className={styles.item}>
          <span className={styles.value}>
            {formatNumber(selfData.balance_withdrawal_usdt_check)}
          </span>
        </h4>
      </div>
    </div>
  );
};

export default SelfStats;
